import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { FaPlus, FaList, FaTimes } from 'react-icons/fa';

const FABContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1500;

  @media (max-width: 480px) {
    bottom: 15px;
    right: 15px;
  }
`;

const MainFAB = styled.button`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--primary-color);
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${props => props.isOpen ? 'rotate(45deg)' : 'rotate(0deg)'};

  &:hover {
    background-color: #2d5016;
    transform: ${props => props.isOpen ? 'rotate(45deg) scale(1.1)' : 'scale(1.1)'};
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: ${props => props.isOpen ? 'rotate(45deg) scale(0.95)' : 'scale(0.95)'};
  }

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
    font-size: 18px;
  }
`;

const FABMenu = styled.div`
  position: absolute;
  bottom: 70px;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transform: ${props => props.isOpen ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.3s ease;

  @media (max-width: 480px) {
    bottom: 60px;
    gap: 10px;
  }
`;

const FABMenuItem = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: white;
  border: none;
  color: var(--primary-color);
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background: #f8f9fa;
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 480px) {
    width: 44px;
    height: 44px;
    font-size: 14px;
  }
`;

function FloatingActionButton() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsOpen(false);
  };

  const scrollToList = () => {
    const listSection = document.querySelector('[data-events-section], [data-list-section]');
    if (listSection) {
      listSection.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  const getActions = () => {
    if (location.pathname === '/admin' || 
        location.pathname === '/admin/news' || 
        location.pathname === '/admin/new-arrivals') {
      return [
        { icon: FaPlus, action: scrollToTop },
        { icon: FaList, action: scrollToList }
      ];
    }
    return [{ icon: FaList, action: scrollToList }];
  };

  const actions = getActions();

  return (
    <FABContainer>
      <FABMenu isOpen={isOpen}>
        {actions.map((action, index) => (
          <FABMenuItem key={index} onClick={action.action}>
            <action.icon />
          </FABMenuItem>
        ))}
      </FABMenu>
      
      <MainFAB isOpen={isOpen} onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaPlus />}
      </MainFAB>
    </FABContainer>
  );
}

export default FloatingActionButton;